import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { Flame, TrendingUp } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
export function OfferUrgency() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const blocks = [{
    value: pad(hours),
    label: 'HORAS'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEG'
  }];
  return <section className="py-12 bg-pastel-white" data-id="element-233">
      <div className="container mx-auto px-5 sm:px-8 lg:px-12" data-id="element-234">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-2xl mx-auto bg-gradient-to-br from-pastel-lavender-dark via-pastel-pink to-pastel-lavender-dark rounded-3xl p-8 sm:p-10 text-center shadow-2xl shadow-pastel-lavender-dark/20 overflow-hidden" data-id="element-235">
          {/* Soft glow */}
          <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-72 h-72 bg-white/30 blur-[80px] rounded-full pointer-events-none" data-id="element-236"></div>

          <div className="relative z-10" data-id="element-237">
            {/* Pill */}
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/25 backdrop-blur-sm border border-white/40 text-white font-bold text-xs sm:text-sm uppercase tracking-wider mb-6" data-id="element-238">
              <Flame size={14} className="text-yellow-200" data-id="element-239" />
              La oferta cierra en
            </div>

            {/* Countdown blocks */}
            <div className="flex items-center justify-center gap-2 sm:gap-4 mb-6" data-id="element-240">
              {blocks.map((b, i) => <Fragment key={b.label} data-id="element-241">
                  <div className="flex flex-col items-center" data-id="element-242">
                    <div className="bg-white/95 backdrop-blur-sm rounded-2xl px-4 sm:px-6 py-3 sm:py-4 min-w-[70px] sm:min-w-[90px] shadow-lg" data-id="element-243">
                      <div className="font-display font-bold text-3xl sm:text-5xl text-pastel-lavender-dark tabular-nums leading-none" data-id="element-244">
                        {b.value}
                      </div>
                    </div>
                    <div className="text-xs text-white/90 font-bold tracking-widest mt-2" data-id="element-245">
                      {b.label}
                    </div>
                  </div>
                  {i < blocks.length - 1 && <div className="text-white text-3xl sm:text-5xl font-display font-bold pb-6" data-id="element-246">
                      :
                    </div>}
                </Fragment>)}
            </div>

            {/* After raise line */}
            <p className="text-white text-base sm:text-lg font-bold mb-6" data-id="element-247">
              Después sube <span className="text-yellow-200" data-id="element-248">$15.000 ARS</span>{' '}
              <span className="underline decoration-yellow-200/70" data-id="element-249">
                y no vuelve a bajar.
              </span>
            </p>

            {/* Capacity bar */}
            <div className="bg-white/20 backdrop-blur-sm border border-white/30 rounded-2xl p-4 text-left" data-id="element-250">
              <div className="flex items-center justify-between mb-2 text-sm" data-id="element-251">
                <div className="flex items-center gap-2 text-white" data-id="element-252">
                  <TrendingUp size={16} className="text-yellow-200" data-id="element-253" />
                  <span data-id="element-254">Cupos al precio de lanzamiento</span>
                </div>
                <span className="font-bold text-yellow-200" data-id="element-255">68% tomados</span>
              </div>
              <div className="w-full bg-white/25 rounded-full h-2.5 overflow-hidden" data-id="element-256">
                <motion.div initial={{
                width: 0
              }} whileInView={{
                width: '68%'
              }} viewport={{
                once: true
              }} transition={{
                duration: 1.2,
                ease: 'easeOut'
              }} className="h-full bg-gradient-to-r from-yellow-200 to-yellow-300 rounded-full" data-id="element-257" />
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}